export default [
  {
    path:"/",
    name: "index",
    meta: {
      authRequired:true
    }
  },
  {
    path: '/404',
    name: '404',
    meta: {
      authRequired: false,
      title: "notfound"
    },
    component: () => import('./views/errors/404')
  },
  {
    path: '/:organisationcode',
    name: 'search',
    meta: {
      authRequired: false,
      title: "search"

    },
    component: () => import('./views/search/default'),
  },
  {
    path: '/:organisationcode/configurations/clientactions',
    name: 'clientactions',
    meta: {
      authRequired: true,
      title: "configuration"
    },
    component: () => import('./views/configuration/clientactions/default'),
  },
  {
    path: '/:organisationcode/configurations/steps',
    name: 'steps',
    meta: {
      authRequired: true,
      title: "configuration"
    },
    component: () => import('./views/configuration/steps/default'),
  },
  {
    path: '/:organisationcode/workorders/',
    name: 'workorders',
    meta: {
      authRequired: true,
      title: "projectlist"
    },
    component: () => import('./views/workorders/default'),
  },
  {
    path: '/:organisationcode/:trackingnumber',
    name: 'workorder',
    meta: {
      authRequired: false,
    },
    component: () => import('./views/workorder/default'),
  }
  // {
  //   path: '/404',
  //   name: '404',
  //   component: require('./views/utility/404').default,
  // },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
]
